import {Component, Injectable} from '@angular/core';
import {MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import {Subject} from 'rxjs';

@Injectable()
export class CustomPaginatorIntl implements MatPaginatorIntl {
  changes = new Subject<void>();

  // For internationalization, the `$localize` function from
  // the `@angular/localize` package can be used.
  firstPageLabel = `Първа страница`;
  itemsPerPageLabel = `Обекта на страница:`;
  lastPageLabel = `Последна страница`;

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = 'Следваща страница';
  previousPageLabel = 'Предишна страница';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `Страница 1 от 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Страница ${page + 1} от ${amountPages}`;
  }
}
